export const brandConfigObjectMap = new Map();

export const Brands = {
    MtnYellowRush: 4,
    WpGemQueens: 90,
    MtnMzansiRhythm: 35,
    UnlockMore: 92,
    UnlockYello: 37
}

export const GameToBrandMap = new Map();
GameToBrandMap.set(4, Brands.MtnYellowRush);
GameToBrandMap.set(90, Brands.WpGemQueens);
GameToBrandMap.set(35, Brands.MtnMzansiRhythm);
GameToBrandMap.set(92, Brands.UnlockMore);
GameToBrandMap.set(37, Brands.UnlockYello);

brandConfigObjectMap.set(Brands.MtnYellowRush, {
    gameTitle: 'Y\'ello Rush',
    gameTag: 'yello-rush',
    brand: 'mtn-yellow-rush',
    serviceId: 12,
    gameUrl: 'https://www.yellorush.co.za',
    termsConditionsUrl: 'https://www.yellorush.co.za/terms-conditions',
    productId: 4,
    backgroundColor: '#101b30',
    textColor: '#fff',
    secondryTextColor: '#aba9a9',
    borderColor: '',
    voucherBackground: true,
    redeemButton: true,
})

brandConfigObjectMap.set(Brands.WpGemQueens, {
    gameTitle: 'Gem Queens',
    gameTag: 'gem-queens',
    brand: 'wp-gem-queens',
    serviceId: 183,
    gameUrl: 'https://gemqueens.co',
    termsConditionsUrl: '',
    showTermsConditions: false,
    productId: 90,
    backgroundColor: '#fff',
    textColor: '#000',
    secondryTextColor: '#aba9a9',
    borderColor: '#FFCA00',
})

brandConfigObjectMap.set(Brands.MtnMzansiRhythm, {
    gameTitle: 'Mzansi Rhythm',
    gameTag: 'mzansi-rhythm',
    brand: 'mtn-mzansi-rhythm',
    gameUrl: 'https://mzrhythm.com',
    termsConditionsUrl: '',
    productId: 35,
    backgroundColor: '#fff',
    textColor: '#000',
    secondryTextColor: '#aba9a9',
    borderColor: '#FFCA00',
})

brandConfigObjectMap.set(Brands.UnlockMore, {
    gameTitle: 'Unlock More VIP',
    gameTag: 'unlock-more',
    brand: 'mtn-unlock-more',
    gameUrl: 'https://unlockmore.co.za/',
    termsConditionsUrl: '',
    productId: 92,
    backgroundColor: '#181818',
    textColor: '#fff',
    secondryTextColor: '#aba9a9',
    borderColor: '#181818',
})

brandConfigObjectMap.set(Brands.UnlockYello, {
    gameTitle: 'Unlock Yello',
    gameTag: 'unlock-yellow',
    brand: 'mtn-unlock-yellow',
    gameUrl: 'http://unlockyellow.mobi/opt_in',
    termsConditionsUrl: '',
    productId: 37,
    backgroundColor: '#181818',
    textColor: '#fff',
    secondryTextColor: '#aba9a9',
    borderColor: '#181818',
})